import PropTypes from 'prop-types';
import {lazy, Suspense, useEffect, useState} from 'react';
import {getAssistantConfig} from 'api/assistant';

const DifyAssistant = lazy(() => import('ui/DifyAssistant'));

const AssistantSwitch = ({token}) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    setEnabled(false);
    getAssistantConfig(token, controller.signal)
      .then(config => {
        const valid =
          config &&
          typeof config === 'object' &&
          !Array.isArray(config) &&
          Object.keys(config).length === 1 &&
          typeof config.enabled === 'boolean';
        setEnabled(valid && config.enabled);
      })
      .catch(error => {
        if (error.name !== 'AbortError') setEnabled(false);
      });
    return () => controller.abort();
  }, [token]);

  if (!enabled) return null;
  return (
    <Suspense fallback={null}>
      <DifyAssistant token={token} />
    </Suspense>
  );
};

AssistantSwitch.propTypes = {token: PropTypes.string.isRequired};

export default AssistantSwitch;
